;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { useEffect } from 'react'

import { useLatestRef } from './use-latest-ref'

export function useInterval(callback: () => void, delay: number | null) {
  const latestCallbackRef = useLatestRef(callback)

  useEffect(() => {
    function tick() {
      latestCallbackRef.current()
    }

    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay, latestCallbackRef])
}
